/**
 * useDownload Hook
 * Updated to match backend API_ROUTES_FINAL.md specification.
 * Custom hook for creating and managing download jobs.
 * 
 * All variable names, logs, and comments are in English.
 */

import { useApi } from './useApi';
import { downloadApi } from '../api';
import type { DownloadResponse } from '../../types/api';

import type { PlatformId } from '../../config/platforms';

interface DownloadParams {
  url: string;
  platform: PlatformId;
  format: string;
  quality: string;
}

export function useDownload() {
  const { loading, error, data, trigger } = useApi<DownloadResponse, DownloadParams>(
    async ({ url, platform, format, quality }) => {
      return await downloadApi.createDownloadJob(url, platform, format, quality);
    }
  );

  const getDownloadStreamUrl = (jobId: string): string => {
    return downloadApi.getDownloadStreamUrl(jobId);
  };

  return {
    loading,
    error,
    downloadJob: data,
    createDownloadJob: trigger,
    getDownloadStreamUrl
  };
}

export default useDownload;
